import React from 'react';
import propTypes from 'prop-types';
import { Icon, Card, Button } from '@tcc/crate';

import { getMessage } from 'i18n/i18nWrapper';

import SendEmail from './SendEmail';
import Logout from './Logout';

import styles from './css/shared.css';

const VerificationFailed = ({error, isVerified, email, redirectUser}) => (
  <div className={styles.container}>
    <Card className={styles.card}>
      <div data-test-id="climate-fv-logo">
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
      </div>
      <div>
        <div data-test-id="verification-failed-message">
          <p className={styles.message}>
            {error}
          </p>
          <p className={styles.message}>
            {getMessage(
              isVerified ? 'verificationFailed.verified' : 'verificationFailed.unverified'
            )}
          </p>
        </div>
        <div className={styles.action}>
          {isVerified ? (
            <Button mode="primary" onClick={redirectUser} testId="redirect-user">
              {getMessage('verificationFailed.continue')}
            </Button>
          ) : (
            <SendEmail email={email} />
          )}
        </div>
      </div>
    </Card>
    <Logout />
  </div>
);

VerificationFailed.propTypes = {
  email: propTypes.string,
  error: propTypes.string.isRequired,
  isVerified: propTypes.bool.isRequired,
  redirectUser: propTypes.func
};

export default VerificationFailed;
